import React from 'react'
import createIcon from '@/lib/create-icon'

export const DarkCircleIcon = createIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_10741_189497)">
      <path d="M8.00004 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8.00004 1.33331C4.31814 1.33331 1.33337 4.31808 1.33337 7.99998C1.33337 11.6819 4.31814 14.6666 8.00004 14.6666Z" fill="#FAF9F6" stroke="#191917" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_10741_189497">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,
)
